module.exports = __webpack_public_path__ + "static/media/badge.6468e8d8.svg";